import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {isIssuesEnabled} from '@github-ui/repo-app-flags'

// Issues' routes can be registered under the unified `repo` app when the
// `repo_app_issues` flag is on. The app's identity stays `issues`, but in that
// case its query keys must use `repo` so they match the running app. The
// resolver is only evaluated when a query key is built (runtime), so it can
// safely read the flag.
export const issuesAppBuilder = DataRouterApplicationBuilder.create('issues', {
  queryKeyAppName: () => (isIssuesEnabled() ? 'repo' : 'issues'),
})
